// removed by extract-text-webpack-plugin
module.exports = {"expertise":"styles__expertise___G2FMk","raised":"styles__raised___1KUuc","title":"styles__title___1EIrl","facultyGraphContainer":"styles__facultyGraphContainer___14RX9","show":"styles__show___3lapu","rotate":"styles__rotate___3qYru","fadein":"styles__fadein___1qH1Y","slideFromRight":"styles__slideFromRight___3AiNh","waves":"styles__waves___1gj8L"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/containers/Expertise/styles.scss
// module id = ./resources/assets/js/containers/Expertise/styles.scss
// module chunks = 0